import { render } from "./MultiSelectOperate.vue?vue&type=template&id=4def6455&scoped=true&ts=true"
import script from "./MultiSelectOperate.vue?vue&type=script&lang=ts"
export * from "./MultiSelectOperate.vue?vue&type=script&lang=ts"

import "./MultiSelectOperate.vue?vue&type=style&index=0&id=4def6455&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4def6455"]])

export default __exports__